export const REGISTRATION_PATH = "/b-2026-11-04";
export const REGISTRATION_MEETING_SLUG = "ambassadors-and-defence-attaches-tour-b-2026-11-04";
export const REGISTRATION_TITLE = "Ambassadors’ and Defence Attachés’ Tour";

export type HubSpotForm = { portalId: string; formId: string; region: string };

// Historical registration link metadata; current forms use each meeting's fields.
// HubSpot document permissions apply only to meeting article paths.
export const REGISTRATION_EVENTS: Readonly<Record<string, { title: string; form: HubSpotForm }>> = {
  [REGISTRATION_MEETING_SLUG]: {
    title: REGISTRATION_TITLE,
    form: { portalId: "8682545", formId: "3fd55a28-ab5e-453a-b7c5-6a878a226e6f", region: "na1" },
  },
};

export function isRegistrationMeeting(slug: string): boolean {
  return Object.prototype.hasOwnProperty.call(REGISTRATION_EVENTS, slug);
}

export function registrationTitle(slug: string): string {
  return REGISTRATION_EVENTS[slug]?.title ?? "Protected meeting";
}

// Accept only well-formed form identifiers from the event configuration.
export function parseHubSpotForm(value: unknown): HubSpotForm | null {
  if (!value || typeof value !== "object") return null;
  const v = value as Record<string, unknown>;
  const portalId = String(v["portalId"] ?? v["portal_id"] ?? "");
  const formId = String(v["formId"] ?? v["form_id"] ?? "");
  const region = String(v["region"] ?? "na1");
  if (!/^\d{1,12}$/.test(portalId)) return null;
  if (!/^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/.test(formId)) return null;
  if (!/^(na1|na2|eu1|ap1)$/.test(region)) return null;
  return { portalId, formId, region };
}

// Meeting articles may embed an administrator-configured HubSpot form, so every meeting
// article document gets the HubSpot CSP allowance; no other page does.
export function registrationSlugFromPath(pathname: string): string | null {
  const m = /^\/meetings\/([a-z0-9][a-z0-9-]*)\/?$/.exec(pathname);
  return m?.[1] ?? null;
}

/** Validated HubSpot form configured on the meeting, or null. */
export function meetingHubSpotForm(meeting: { hubspot_portal_id?: string | null; hubspot_form_id?: string | null; hubspot_region?: string | null } | null | undefined): HubSpotForm | null {
  if (!meeting?.hubspot_portal_id || !meeting.hubspot_form_id) return null;
  return parseHubSpotForm({ portal_id: meeting.hubspot_portal_id, form_id: meeting.hubspot_form_id, region: meeting.hubspot_region ?? "na1" });
}

// CSP belongs to the original document, not the current client-side route.
export function registrationDocumentReloadRequired(documentPathname: string, destinationPathname: string): boolean {
  return registrationSlugFromPath(documentPathname) !== registrationSlugFromPath(destinationPathname);
}

export function registrationGuestAuthorized(result: { status: string; tier: string | null; meeting: { slug: string } | null; expiresAt: string | null }, slug = REGISTRATION_MEETING_SLUG, now = Date.now()): boolean {
  return isRegistrationMeeting(slug) && result.status === "ok" && result.tier === "guest" &&
    result.meeting?.slug === slug &&
    result.expiresAt !== null && Date.parse(result.expiresAt) > now;
}
